<template>
    <div class="left_panel">
        <h2
            class="font_size_20 font-weight-bold mb-0 text_black edit_profile_heading"
        >
            Patch Inventory
        </h2>
        <div class="subhead font_size_16 text_light_grey mb-0">
            View your unused patches from previous orders
        </div>

        <div class="mt_30">
            <div v-if="isLoading" class="text-center py-5">
                <div class="preloader" style="position: relative; height: 80px;">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            <div v-else-if="patchInventory.length === 0" class="text-center py-5">
                <div class="empty-state">
                    <img
                        src="/maincss/images/saved_design.svg"
                        alt=""
                        style="width: 60px; opacity: 0.4;"
                        class="mb_20"
                    />
                    <p class="font_size_16 text_light_grey mb-0">
                        No patch inventory available.
                    </p>
                    <p class="font_size_14 text_light_grey">
                        Unused patches from your orders will appear here.
                    </p>
                </div>
            </div>

            <div v-else>
                <div class="table-responsive">
                    <table class="table patch-inventory-table">
                        <thead>
                            <tr>
                                <th class="font_size_14 font-weight-bold">Patch Name</th>
                                <th class="font_size_14 font-weight-bold">Material</th>
                                <th class="font_size_14 font-weight-bold">Dimensions</th>
                                <th class="font_size_14 font-weight-bold text-center">Total Purchased</th>
                                <th class="font_size_14 font-weight-bold text-center">Remaining</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="inv in patchInventory" :key="inv.id">
                                <td class="font_size_14 align-middle">
                                    <div class="d-flex align-items-center">
                                        <img
                                            v-if="inv.patch && inv.patch.image_path"
                                            :src="inv.patch.image_path"
                                            alt=""
                                            class="patch-thumb mr_10"
                                            @error="$event.target.style.display='none'"
                                        />
                                        <span>{{ inv.patch ? inv.patch.image_name : ('Patch #' + inv.patch_id) }}</span>
                                    </div>
                                </td>
                                <td class="font_size_14 align-middle">
                                    {{ inv.material ? inv.material.name : '-' }}
                                </td>
                                <td class="font_size_14 align-middle">
                                    {{ formatDimensions(inv) }}
                                </td>
                                <td class="font_size_14 align-middle text-center">
                                    {{ inv.total_quantity }}
                                </td>
                                <td class="font_size_14 align-middle text-center">
                                    <span
                                        class="remaining-badge"
                                        :class="{
                                            'remaining-low': inv.remaining_quantity > 0 && inv.remaining_quantity <= 10,
                                            'remaining-good': inv.remaining_quantity > 10,
                                            'remaining-zero': inv.remaining_quantity === 0
                                        }"
                                    >
                                        {{ inv.remaining_quantity }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
    name: "PatchInventory",
    data() {
        return {
            patchInventory: [],
            isLoading: false
        };
    },
    mounted() {
        this.loadPatchInventory();
        document.body.classList.add("bg_primary_light_white");
    },
    methods: {
        loadPatchInventory() {
            this.isLoading = true;
            ApiService.get("/my-patch-inventory")
                .then(({ data }) => {
                    this.patchInventory = data.inventory || [];
                })
                .catch(() => {
                    this.patchInventory = [];
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatDimensions(inv) {
            const w = inv.width || (inv.patch && inv.patch.width);
            const h = inv.height || (inv.patch && inv.patch.height);
            if (w && h) return w + '" x ' + h + '"';
            return '-';
        }
    }
};
</script>
<style scoped>
.patch-inventory-table {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
}
.patch-inventory-table thead tr {
    background: #f5f7fa;
    border-bottom: 2px solid #e8ecf1;
}
.patch-inventory-table thead th {
    color: #2b2b2b;
    padding: 14px 16px;
    white-space: nowrap;
    border: none;
}
.patch-inventory-table tbody td {
    padding: 14px 16px;
    border-bottom: 1px solid #f0f0f0;
    color: #333;
}
.patch-inventory-table tbody tr:hover {
    background: #f9fbfd;
}
.patch-thumb {
    width: 36px;
    height: 36px;
    object-fit: contain;
    border: 1px solid #e8ecf1;
    border-radius: 4px;
    padding: 2px;
}
.remaining-badge {
    display: inline-block;
    min-width: 36px;
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 14px;
}
.remaining-good {
    background: #e8f5e9;
    color: #2e7d32;
}
.remaining-low {
    background: #fff3e0;
    color: #e65100;
}
.remaining-zero {
    background: #fce4ec;
    color: #c62828;
}
.empty-state {
    padding: 40px 20px;
}
</style>
